import { FC } from "react";
import { copy } from "shared/assets";
import { Question } from "shared/assets/icons";
import { APIErrorMessage, Button, Loader, Modal } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIError, ITheme } from "shared/types";

interface Props {
  handleSave: () => void;
  handleClose: () => void;
  handleNextLocation: () => void;
  isSubmitting?: boolean;
  error?: string;
  apiError?: IAPIError | null;
}

export const SaveChangesModal: FC<Props> = ({
  handleSave,
  handleClose,
  handleNextLocation,
  isSubmitting,
  error,
  apiError,
}) => {
  return (
    <Modal
      icon={Question}
      title={"Hold up — You’ve got unsaved changes"}
      handleClose={handleClose}
    >
      <Spacer size="l">
        <span>
          You’ve been editing this member’s permissions, but didn’t hit save
          yet. If you leave now, all changes will be lost.
        </span>
        <Spacer size="s" spaceDirection="horizontal">
          <Button onClick={handleSave} disabled={isSubmitting} type="submit">
            <span>Save my changes</span>
            {isSubmitting && <Loader size="s" />}
          </Button>
          <Button onClick={handleNextLocation} theme={ITheme.secondary}>
            Leave without saving
          </Button>
          <Button onClick={handleClose} theme={ITheme.secondary}>
            Cancel
          </Button>
        </Spacer>
        {(error || apiError) && (
          <APIErrorMessage
            apiErrorMessage={error || copy.errors.general}
            apiError={apiError}
          />
        )}
      </Spacer>
    </Modal>
  );
};
